import { graphql } from "@opensea/graphql"

export const FeaturedItemsCarouselFragment = graphql(`
  fragment FeaturedItemsCarousel on CollectionContentBlockModule {
    sections {
      __typename
      ... on FeatureContentBlock {
        id
        itemId
      }
    }
  }
`)
